import { Badge } from '@/components/ui/badge';
import type { InvoiceEmailLog } from '@/types';

const KIND = {
  invoice: { label: 'Invoice', tone: 'accent' },
  follow_up: { label: 'Follow-up', tone: 'warning' },
  reminder: { label: 'Auto reminder', tone: 'warning' },
  receipt: { label: 'Receipt', tone: 'positive' }
} as const;

export function EmailKindBadge({ kind }: { kind: InvoiceEmailLog['kind'] }) {
  const { label, tone } = KIND[kind] ?? KIND.invoice;
  return <Badge tone={tone}>{label}</Badge>;
}
